import { EffectHandler } from "../types/editor"
import { toast } from "@/utils/util"

const phoneticsHandler: EffectHandler = {
    // 添加
    addEffect(editor, selection, value) {
        editor.addcontainEffectHtml({
            range: selection.range,
            effectType: 'phonetics',
            effectUIType:'phoneticsInner',
            idName: 'phoneticsId',
            param: {
                phoneticsText: value,
                originPron:selection.rangeText,
            }
        })
    },
    // 修改
    modifyEffect(editor, selection, value) { },
    // 删除
    removeEffect(editor, selection) { },
        // 获取当前选中文字
    
    beforeSheetOpen(editor, selection){
        let regExp= /^[A-Za-z]+$/
        if(!regExp.test(selection.rangeText)){
            toast("请选择英文单词")
            return false
        }
        return true
    }
}
export default phoneticsHandler